import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useWidgetDispatch, useWidgetSelector } from "../../../store/store";
import { NextButton } from "../../shared/Buttons/NavigationButtons";
import { State } from "../../../store/state";
import { setRecurring, nextPane } from "../../../store/actions";
import { RecurringDonation } from "../../../types/Enums";
import { AmountContext, OperationsConfig, CauseAreaDisplayConfig, UILabels, SmartDistributionContext } from "../../../types/WidgetProps";
import { CauseAreaForm } from "./CauseAreaForm";
import { SmartDistributionForm } from "./SmartDistributionForm";
import { OperationsCauseAreaForm } from "./OperationsCauseAreaForm";
import { GlobalCutToggle } from "./GlobalCutToggle";
import { useAmountCalculation } from "./useAmountCalculation";
import { thousandize } from "../../../../../../../util/formatting";
import { RadioButtonGroup } from "../../../../RadioButton/RadioButtonGroup";
import { usePrefilledCauseAreaIds } from "../../hooks";
import panes from "../Panes.module.scss";
import styles from "../AmountPane.module.scss";
interface AmountPaneProps {
  nextButtonText: string;
  smartDistContext: SmartDistributionContext;
  text: {
    single_donation_text: string;
    monthly_donation_text: string;
  };
  enableRecurring: boolean;
  enableSingle: boolean;
  amountContext: AmountContext;
  operationsConfig?: OperationsConfig;
  causeAreaDisplayConfig?: CauseAreaDisplayConfig;
  uiLabels?: UILabels;
}
export const AmountPane: React.FC<AmountPaneProps> = t0 => {
  const $ = _c(88);
  const {
    nextButtonText,
    smartDistContext,
    text,
    enableRecurring,
    enableSingle,
    amountContext,
    operationsConfig,
    causeAreaDisplayConfig,
    uiLabels
  } = t0;
  const dispatch = useWidgetDispatch();
  const {
    selectionType,
    selectedCauseAreaId,
    recurring,
    smartDistributionTotal
  } = useWidgetSelector(_temp);
  const causeAreas = useWidgetSelector(_temp2) || [];
  const prefilledCauseAreaIds = usePrefilledCauseAreaIds();
  const {
    totalAmount,
    causeAreaAmounts,
    orgAmounts,
    causeAreaDistributionType
  } = useAmountCalculation(selectionType || "single", selectedCauseAreaId || null, causeAreas);
  let t1;
  if ($[0] !== dispatch) {
    t1 = () => {
      dispatch(nextPane());
    };
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleNext = t1;
  const effectiveTotal = selectedCauseAreaId === -1 ? smartDistributionTotal || 0 : totalAmount;
  const suggestedSums = recurring ? amountContext.preset_amounts_recurring : amountContext.preset_amounts_single;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] !== causeAreaAmounts || $[3] !== causeAreaDisplayConfig || $[4] !== causeAreaDistributionType || $[5] !== causeAreas || $[6] !== dispatch || $[7] !== enableRecurring || $[8] !== enableSingle || $[9] !== operationsConfig || $[10] !== orgAmounts || $[11] !== prefilledCauseAreaIds || $[12] !== recurring || $[13] !== selectedCauseAreaId || $[14] !== selectionType || $[15] !== smartDistContext || $[16] !== suggestedSums || $[17] !== text || $[18] !== totalAmount || $[19] !== uiLabels?.total_label) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t9;
      if ($[27] !== selectedCauseAreaId) {
        t9 = c => c.id === selectedCauseAreaId;
        $[27] = selectedCauseAreaId;
        $[28] = t9;
      } else {
        t9 = $[28];
      }
      const selectedCA = causeAreas.find(t9);
      if (!causeAreaDisplayConfig) {
        let t10;
        if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = <span>Missing cause area display config</span>;
          $[29] = t10;
        } else {
          t10 = $[29];
        }
        t8 = t10;
        break bb0;
      }
      t7 = panes.pane;
      t6 = panes.paneContainer;
      const t10 = !enableSingle;
      let t11;
      if ($[30] !== t10 || $[31] !== text.single_donation_text) {
        t11 = {
          title: text.single_donation_text,
          value: RecurringDonation.NON_RECURRING,
          disabled: t10,
          data_cy: "single-donation-radio"
        };
        $[30] = t10;
        $[31] = text.single_donation_text;
        $[32] = t11;
      } else {
        t11 = $[32];
      }
      const t12 = !enableRecurring;
      let t13;
      if ($[33] !== t12 || $[34] !== text.monthly_donation_text) {
        t13 = {
          title: text.monthly_donation_text,
          value: RecurringDonation.RECURRING,
          disabled: t12,
          data_cy: "recurring-donation-radio"
        };
        $[33] = t12;
        $[34] = text.monthly_donation_text;
        $[35] = t13;
      } else {
        t13 = $[35];
      }
      let t14;
      if ($[36] !== t11 || $[37] !== t13) {
        t14 = [t11, t13];
        $[36] = t11;
        $[37] = t13;
        $[38] = t14;
      } else {
        t14 = $[38];
      }
      let t15;
      if ($[39] !== dispatch) {
        t15 = val => dispatch(setRecurring(val));
        $[39] = dispatch;
        $[40] = t15;
      } else {
        t15 = $[40];
      }
      if ($[41] !== recurring || $[42] !== t14 || $[43] !== t15) {
        t5 = <div className={styles.recurringSelectionWrapper}><RadioButtonGroup options={t14} selected={recurring} onSelect={t15} /></div>;
        $[41] = recurring;
        $[42] = t14;
        $[43] = t15;
        $[44] = t5;
      } else {
        t5 = $[44];
      }
      t2 = styles.causeAreasWrapper;
      if ($[45] !== causeAreaAmounts || $[46] !== causeAreaDisplayConfig || $[47] !== causeAreaDistributionType || $[48] !== causeAreas || $[49] !== operationsConfig || $[50] !== orgAmounts || $[51] !== prefilledCauseAreaIds || $[52] !== selectedCauseAreaId || $[53] !== selectionType || $[54] !== smartDistContext || $[55] !== suggestedSums || $[56] !== totalAmount || $[57] !== uiLabels?.total_label) {
        t3 = selectionType === "multiple" && selectedCauseAreaId !== -1 && <><SmartDistributionForm suggestedSums={suggestedSums} totalAmount={totalAmount} causeAreas={causeAreas} causeAreaAmounts={causeAreaAmounts} causeAreaDistributionType={causeAreaDistributionType} smartDistributionContext={smartDistContext} causeAreaDisplayConfig={causeAreaDisplayConfig} />{causeAreas.filter(ca => ca.isActive || prefilledCauseAreaIds.has(ca.id)).filter(ca_0 => !causeAreaDisplayConfig?.below_line_cause_area_ids?.includes(ca_0.id)).map(ca_1 => <CauseAreaForm key={ca_1.id} causeArea={ca_1} isSingleSelection={false} suggestedSums={suggestedSums} causeAreaAmounts={causeAreaAmounts} orgAmounts={orgAmounts} causeAreaDistributionType={causeAreaDistributionType} showOperationsOption={false} operationsConfig={operationsConfig} causeAreaDisplayConfig={causeAreaDisplayConfig} smartDistributionContext={smartDistContext} />)}<GlobalCutToggle operationsConfig={operationsConfig} /><div className={styles.totalAmountWrapper} data-cy="total-amount-wrapper"><div>{uiLabels?.total_label}</div><div>{thousandize(totalAmount)} kr</div></div></>;
        $[45] = causeAreaAmounts;
        $[46] = causeAreaDisplayConfig;
        $[47] = causeAreaDistributionType;
        $[48] = causeAreas;
        $[49] = operationsConfig;
        $[50] = orgAmounts;
        $[51] = prefilledCauseAreaIds;
        $[52] = selectedCauseAreaId;
        $[53] = selectionType;
        $[54] = smartDistContext;
        $[55] = suggestedSums;
        $[56] = totalAmount;
        $[57] = uiLabels?.total_label;
        $[58] = t3;
      } else {
        t3 = $[58];
      }
      t4 = selectionType === "single" && selectedCA && <>{selectedCA.id === operationsConfig?.operations_cause_area_id ? <OperationsCauseAreaForm causeArea={selectedCA} suggestedSums={suggestedSums} causeAreaAmounts={causeAreaAmounts} causeAreaDisplayConfig={causeAreaDisplayConfig} /> : <><CauseAreaForm causeArea={selectedCA} isSingleSelection={true} suggestedSums={suggestedSums} causeAreaAmounts={causeAreaAmounts} orgAmounts={orgAmounts} causeAreaDistributionType={causeAreaDistributionType} showOperationsOption={!operationsConfig?.excluded_cause_area_ids?.includes(selectedCA.id)} operationsConfig={operationsConfig} causeAreaDisplayConfig={causeAreaDisplayConfig} smartDistributionContext={smartDistContext} /></>}</>;
    }
    $[2] = causeAreaAmounts;
    $[3] = causeAreaDisplayConfig;
    $[4] = causeAreaDistributionType;
    $[5] = causeAreas;
    $[6] = dispatch;
    $[7] = enableRecurring;
    $[8] = enableSingle;
    $[9] = operationsConfig;
    $[10] = orgAmounts;
    $[11] = prefilledCauseAreaIds;
    $[12] = recurring;
    $[13] = selectedCauseAreaId;
    $[14] = selectionType;
    $[15] = smartDistContext;
    $[16] = suggestedSums;
    $[17] = text;
    $[18] = totalAmount;
    $[19] = uiLabels?.total_label;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t2 = $[20];
    t3 = $[21];
    t4 = $[22];
    t5 = $[23];
    t6 = $[24];
    t7 = $[25];
    t8 = $[26];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[59] !== causeAreaAmounts || $[60] !== causeAreaDisplayConfig || $[61] !== causeAreaDistributionType || $[62] !== causeAreas || $[63] !== operationsConfig || $[64] !== selectedCauseAreaId || $[65] !== smartDistContext || $[66] !== suggestedSums || $[67] !== totalAmount) {
    t9 = selectedCauseAreaId === -1 && <><SmartDistributionForm suggestedSums={suggestedSums} totalAmount={totalAmount} causeAreas={causeAreas} causeAreaAmounts={causeAreaAmounts} causeAreaDistributionType={causeAreaDistributionType} smartDistributionContext={smartDistContext} causeAreaDisplayConfig={causeAreaDisplayConfig} /><GlobalCutToggle operationsConfig={operationsConfig} /></>;
    $[59] = causeAreaAmounts;
    $[60] = causeAreaDisplayConfig;
    $[61] = causeAreaDistributionType;
    $[62] = causeAreas;
    $[63] = operationsConfig;
    $[64] = selectedCauseAreaId;
    $[65] = smartDistContext;
    $[66] = suggestedSums;
    $[67] = totalAmount;
    $[68] = t9;
  } else {
    t9 = $[68];
  }
  let t10;
  if ($[69] !== t2 || $[70] !== t3 || $[71] !== t4 || $[72] !== t9) {
    t10 = <div className={t2}>{t3}{t4}{t9}</div>;
    $[69] = t2;
    $[70] = t3;
    $[71] = t4;
    $[72] = t9;
    $[73] = t10;
  } else {
    t10 = $[73];
  }
  let t11;
  if ($[74] !== t10 || $[75] !== t5) {
    t11 = <div>{t5}{t10}</div>;
    $[74] = t10;
    $[75] = t5;
    $[76] = t11;
  } else {
    t11 = $[76];
  }
  const t12 = effectiveTotal <= 0;
  let t13;
  if ($[77] !== handleNext || $[78] !== nextButtonText || $[79] !== t12) {
    t13 = <div className={styles.actionBar}><NextButton disabled={t12} onClick={handleNext} data-cy="next-button">{nextButtonText}</NextButton></div>;
    $[77] = handleNext;
    $[78] = nextButtonText;
    $[79] = t12;
    $[80] = t13;
  } else {
    t13 = $[80];
  }
  let t14;
  if ($[81] !== t11 || $[82] !== t13 || $[83] !== t6) {
    t14 = <div className={t6}>{t11}{t13}</div>;
    $[81] = t11;
    $[82] = t13;
    $[83] = t6;
    $[84] = t14;
  } else {
    t14 = $[84];
  }
  let t15;
  if ($[85] !== t14 || $[86] !== t7) {
    t15 = <div className={t7}>{t14}</div>;
    $[85] = t14;
    $[86] = t7;
    $[87] = t15;
  } else {
    t15 = $[87];
  }
  return t15;
};
function _temp(state) {
  return state.donation;
}
function _temp2(state_0) {
  return state_0.layout.causeAreas;
}